/** Shared NI 45-110 investor withdrawal / cancellation language (Canada). */

import { WITHDRAWAL_NOTICE_EMAIL } from "lib/fortifyContact";

export { WITHDRAWAL_NOTICE_EMAIL };

/** Statutory deadline phrase — use in full sentences. */
export const WITHDRAWAL_DEADLINE_PHRASE =
  "not later than midnight Eastern Time on the second business day after the day on which you entered into the subscription agreement";

export const WITHDRAWAL_DEADLINE_AFTER_AMENDMENT_PHRASE =
  "not later than midnight Eastern Time on the second business day after the amendment notification";

export const WITHDRAWAL_RIGHT_SUMMARY = `Under NI 45-110, you may withdraw your investment by delivering notice to Fortify Portal, Inc. ${WITHDRAWAL_DEADLINE_PHRASE}. If the offering document is amended, your withdrawal right is re-triggered and you have until ${WITHDRAWAL_DEADLINE_AFTER_AMENDMENT_PHRASE} to withdraw.`;

export const WITHDRAWAL_FAQ_ANSWER = `${WITHDRAWAL_RIGHT_SUMMARY} Send withdrawal and cancellation notices to ${WITHDRAWAL_NOTICE_EMAIL}.`;

/** Form 45-110F2 risk acknowledgement — section 5, bullet 1. */
export const RISK_ACK_WITHDRAWAL_BULLET = `You may cancel (withdraw from) your purchase ${WITHDRAWAL_DEADLINE_PHRASE} by sending a notice to the funding portal at ${WITHDRAWAL_NOTICE_EMAIL}.`;
